import React from 'react';
import PolicyLayout from '../../components/seo/PolicyLayout';

const CookiePolicy = () => {
  return (
    <PolicyLayout 
      title="Cookie Policy" 
      subtitle="Informativa sull'utilizzo dei Cookie"
      lastUpdated="10 Giugno 2025"
    >
      <h3>Cosa sono i cookie?</h3>
      <p>
        I cookie sono piccoli file di testo che i siti web visitati dagli utenti inviano ai loro terminali, 
        dove vengono memorizzati per essere poi ritrasmessi agli stessi siti in occasione di visite successive. 
        I cookie sono utilizzati per diverse finalità, hanno caratteristiche diverse, e possono essere utilizzati 
        sia dal titolare del sito che si sta visitando, sia da terze parti.
      </p>
      
      <h3>Tipologie di cookie utilizzati da questo sito</h3>
      <p>
        Il sito web di Molinaro Immobiliare utilizza i seguenti tipi di cookie:
      </p>
      
      <h4>Cookie tecnici</h4>
      <p>
        Questi cookie sono necessari per il corretto funzionamento del sito e non possono essere disattivati nei nostri sistemi.
        Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, 
        come l'impostazione delle preferenze di privacy, l'accesso o la compilazione di moduli.
      </p>
      <p>
        Puoi impostare il tuo browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito 
        non funzioneranno. Questi cookie non memorizzano informazioni personali.
      </p>
      
      <h4>Cookie analitici</h4>
      <p>
        Utilizziamo cookie analitici, come quelli di Google Analytics, per comprendere come i visitatori interagiscono con il nostro 
        sito raccogliendo e analizzando informazioni in forma anonima. Questi cookie ci aiutano a migliorare il funzionamento del sito web.
      </p>
      <p>
        Le informazioni raccolte includono il numero dei visitatori del sito, da dove sono arrivati e le pagine visitate. 
        Utilizziamo questi dati per compilare report che ci aiutano a migliorare il sito.
      </p>
      
      <h4>Cookie di profilazione</h4>
      <p>
        I cookie di profilazione sono volti a creare profili relativi all'utente e vengono utilizzati al fine di inviare messaggi 
        pubblicitari in linea con le preferenze manifestate dallo stesso nell'ambito della navigazione in rete.
      </p>
      <p>
        Sul nostro sito utilizziamo cookie di profilazione di terze parti per offrirti pubblicità pertinente basata sui tuoi interessi. 
        Questi cookie possono tracciare le tue attività di navigazione su diversi siti web e compilare un profilo delle tue preferenze 
        per rendere la pubblicità più rilevante per te.
      </p>
      
      <h4>Cookie di terze parti</h4>
      <p>
        Nel corso della navigazione su questo sito, potresti ricevere sul tuo terminale anche cookie di siti o di web server diversi 
        (c.d. cookie di "terze parti"): ciò accade perché sul sito possono essere presenti elementi come immagini, mappe, suoni, 
        specifici link a pagine web di altri domini che risiedono su server diversi da quello sul quale si trova la pagina richiesta.
      </p>
      <p>
        In particolare, i cookie di terze parti presenti su questo sito includono:
      </p>
      <ul>
        <li>
          <strong>Google Analytics:</strong> Servizio di analisi web fornito da Google, Inc. ("Google"). 
          Google Analytics utilizza i cookie per analizzare come gli utenti utilizzano il sito.
        </li>
        <li>
          <strong>Social Media:</strong> Utilizziamo pulsanti di condivisione sui social media (Facebook, Instagram) che potrebbero impostare cookie.
        </li>
        <li>
          <strong>Servizi di mappe:</strong> Per le mappe integrate utilizziamo Google Maps, che potrebbe impostare cookie per memorizzare le preferenze dell'utente.
        </li>
      </ul>
      
      <h3>Durata dei cookie</h3>
      <p>
        I cookie hanno una durata dettata dalla data di scadenza (o da un'azione specifica come la chiusura del browser) impostata al momento dell'installazione.
      </p>
      <p>
        In base alla loro durata, si distinguono in:
      </p>
      <ul>
        <li>
          <strong>Cookie di sessione:</strong> Sono utilizzati per archiviare informazioni temporanee, consentono di collegare le azioni
          eseguite durante una sessione specifica e vengono rimossi quando si chiude il browser.
        </li>
        <li>
          <strong>Cookie persistenti:</strong> Sono utilizzati per archiviare informazioni, come il nome e la password di accesso, in modo
          da evitare che l'utente debba digitarli nuovamente ogni volta che visita un sito specifico. Questi rimangono memorizzati nel tuo
          dispositivo anche dopo aver chiuso il browser.
        </li>
      </ul>
      
      <h3>Gestione dei cookie</h3>
      <p>
        Puoi controllare e gestire i cookie in vari modi. Considera che cancellare o bloccare i cookie potrebbe compromettere
        l'esperienza utente e parti del sito potrebbero non funzionare correttamente.
      </p>
      
      <h4>Gestione tramite browser</h4>
      <p>
        La maggior parte dei browser permette di visualizzare, gestire, cancellare e bloccare i cookie del sito.
        Di seguito i link alle impostazioni dei cookie per i browser più comuni:
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
      </ul>
      
      <h4>Gestione tramite sito web</h4>
      <p>
        Il nostro sito web offre un banner per la gestione dei cookie al primo accesso, dove puoi accettare o rifiutare
        determinati tipi di cookie. Puoi modificare le tue preferenze in qualsiasi momento cliccando sul link "Impostazioni Cookie"
        presente nel footer del nostro sito.
      </p>
      
      <h3>Consenso all'uso dei cookie</h3>
      <p>
        Secondo la normativa vigente, non è necessario chiedere consenso per i cookie tecnici, in quanto necessari a fornire il servizio.
        Per tutte le altre tipologie di cookie è necessario il tuo consenso esplicito, che può essere espresso attraverso il banner
        cookie mostrato alla prima visita del sito e revocato in qualsiasi momento.
      </p>
      
      <h3>Aggiornamenti della Cookie Policy</h3>
      <p>
        La presente Cookie Policy può essere aggiornata periodicamente, quindi è consigliabile consultare regolarmente questa pagina
        per assicurarsi di essere aggiornati su qualsiasi modifica. La data dell'ultimo aggiornamento è indicata in cima a questa pagina.
      </p>
      
      <h3>Contatti</h3>
      <p>
        Se hai domande relative alla nostra Cookie Policy, puoi contattarci ai seguenti recapiti:
      </p>
      <p>
        <strong>Molinaro Immobiliare</strong><br />
        Via Pisana 327<br />
        50018 Scandicci (FI)<br />
        Email: privacy@molinaroimmobiliare.it<br />
        Telefono: +39 327 8855115
      </p>
    </PolicyLayout>
  );
};

export default CookiePolicy;